import { render, staticRenderFns } from "./DataConfigInfo.vue?vue&type=template&id=2186c9a3&scoped=true"
import script from "./DataConfigInfo.vue?vue&type=script&lang=js"
export * from "./DataConfigInfo.vue?vue&type=script&lang=js"
import style0 from "./DataConfigInfo.vue?vue&type=style&index=0&id=2186c9a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2186c9a3",
  null
  
)

export default component.exports